import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Solution from "./Solution";
import Benefits from "./Benefits";

export default function Digital() {
  const keyBenefits = [
    {
      icon: "fas fa-tachometer-alt", title: "Enhanced Operational Efficiency",
      description: 'Streamlines processes for faster and more effective results.'
    },
    {
      icon: "fas fa-users", title: "Improved Customer Experience (CX)",
      description: 'Delivers personalized, responsive service to boost satisfaction.'
    },
    {
      icon: "fas fa-chart-line", title: "Data-Driven Decision Making",
      description: ' Leverages insights for more informed business choices.'
    },
    {
      icon: "fas fa-cogs", title: "Scalability and Flexibility",
      description: 'Adapts easily to changing business needs and growth.'
    },
    {
      icon: "fas fa-lightbulb", title: "Increased Innovation and Competitiveness",
      description: 'Drives creative solutions to stay ahead in the market.'
    },
    {
      icon: "fas fa-users-cog", title: "Enhanced Collaboration & Communication",
      description: 'Fosters teamwork and seamless information sharing.'
    },
    {
      icon: "fas fa-shield-alt", title: "Strengthened Cybersecurity and Compliance",
      description: 'Protects data and meets regulatory requirements.'
    },
    {
      icon: "fas fa-coins", title: "Reduced Costs and Increased ROI",
      description: 'Optimizes resources to maximize financial returns.'
    },
    {
      icon: "fas fa-rocket", title: "Future-Proofing the Business",
      description: ' Prepares the organization for future challenges and opportunities.'
    },
    {
      icon: "fas fa-people-carry", title: "Improved Employee Experience",
      description: 'Creates a supportive environment that boosts morale and productivity.'
    },
  ];
  /***overview */
  const services = [
    {
      title: "Digital Strategy and Roadmap Development",
      imgSrc: "images/digital.png",
    },
    {
      title: "Cloud Migration and Infrastructure Modernization",
      imgSrc: "images/server.png",
    },
    {
      title: "Data Analytics and Insights",
      imgSrc: "images/data.png",
    },
    {
      title: "Business Process Automation (BPA)",
      imgSrc: "images/bpa.png",
    },
    {
      title: "Customer Experience (CX) Transformation",
      imgSrc: "images/exper.png",
    },
    {
      title: "Internet of Things (IoT) Solutions",
      imgSrc: "images/iot.png",
    },
    {
      title: "Artificial Intelligence (AI) and Machine Learning (ML) Integration",
      imgSrc: "images/ai.png",
    },
    {
      title: "Digital Culture and Change Management",
      imgSrc: "images/digicul.png",
    },
  ];
  return (
    <>
      <div className="aboutus_bg">
        <div className="aboutus-img-content">
          <h1>Services</h1>

        </div>

      </div>
      <Container className="it-overview text-center mt-5 mb-5">
        {/* <h6>OVERVIEW</h6> */}
        <h3 className="text-center" style={{ color: '#0e2b5c' }}>Digital Transformation</h3>
        <p style={{ padding: '0 12%', color: '#9b9aad', fontWeight: '500' }}>
          Our Digital Transformation professionals will drive the integration of digital technologies across business areas, reshaping operations, enhancing customer experiences, and fostering innovation. We develop and implement strategies to modernize processes, improve efficiency, and create data-driven insights, ensuring organizations remain competitive and adaptable in an evolving digital landscape.
        </p>

        <Container className="py-3 services-main">
          <Row className="g-4">
            {services.map((service, index) => (
              <Col key={index} sm={12} md={12} lg={3}>
                <Card className="text-center shadow-sm h-100 services-its">
                  <Card.Body>
                    <div className="card-img">
                      <img
                        src={service.imgSrc}
                        alt={service.title}
                        className="service-icon"
                        style={{ width: "100px", marginBottom: "30px", marginTop: '35px' }}
                      />
                    </div>
                    <Card.Title>{service.title}</Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </Container>

      {/**key benefits *****************************/}

      <section className="py-5 text-light" style={{ backgroundColor: "#141b29" }}>
        <Container>
          {/* <h6 className="text-uppercase text-center text-info mb-2">
            Key Benefits in managing your hiring needs
          </h6> */}
          <h2 className="text-center mb-5">Key Benefits in managing your hiring needs</h2>
          <Row className="g-4 row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5">
            {keyBenefits.map((benefit, index) => (
              <Col key={index} className="text-center mb-4">
                <Row>
                  <Col md={4}>
                    <i className={`${benefit.icon} fa-2x text-info mb-3`}></i>
                  </Col>
                  <Col md={8}>
                    <h5 style={{ textAlign: 'left' }}>{benefit.title}</h5>
                    <h6 style={{ color: '#9b9aad', textAlign: 'left' }}>{benefit.description}</h6>
                  </Col>
                </Row>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/**PROCESS****************************************** */}

      <section className="py-5" style={{ backgroundColor: "#f8f8f8" }}>
        <Container>
          {/* Section Title */}
          <div className="text-center mb-4">
            {/* <h6 className="text-uppercase text-info">Benefits</h6> */}
            <h2 className="fw-bold mb-4" style={{ color: '#0e2b5c' }}>
              Our Process
            </h2>
          </div>

          {/* Benefits Row */}
          <Row className="g-4">
            {/* Benefit 1 */}
            <Col md={3} className="text-left mb-5">
              <div>
                <div
                  className="mb-2"
                  style={{
                    height: "7px",
                    backgroundColor: "#3d97d3",
                    width: "100%",
                    margin: "0 auto",
                  }}
                ></div>
                <h5 className=" ben-title mt-4 mb-3">Discovery and  Assessment</h5>
                <h6 style={{lineHeight: '1.625em',color:'#627792'}}>Identifies business needs and evaluates current systems.</h6>
              </div>
            </Col>

            {/* Benefit 2 */}
            <Col md={3} className="text-left mb-5">
              <div>
                <div
                  className="mb-2"
                  style={{
                    height: "7px",
                    backgroundColor: "#3d97d3",
                    width: "100%",
                    margin: "0 auto",
                  }}
                ></div>
                <h5 className=" ben-title mt-4 mb-3">Strategy Development and Roadmap Creation</h5>
                <h6 style={{lineHeight: '1.625em',color:'#627792'}}>Develops a clear plan and direction for IT initiatives.</h6>
              </div>
            </Col>

            {/* Benefit 3 */}
            <Col md={3} className="text-left mb-5">
              <div>
                <div
                  className="mb-2"
                  style={{
                    height: "7px",
                    backgroundColor: "#3d97d3",
                    width: "100%",
                    margin: "0 auto",
                  }}
                ></div>
                <h5 className=" ben-title mt-4 mb-3">Technology Selection and Solution Design</h5>
                <h6 style={{lineHeight: '1.625em',color:'#627792'}}>Chooses the right technologies and designs tailored solutions.</h6>
              </div>
            </Col>

            {/* Benefit 4 */}
            <Col md={3} className="text-left mb-5">
              <div>
                <div
                  className="mb-2"
                  style={{
                    height: "7px",
                    backgroundColor: "#3d97d3",
                    width: "100%",
                    margin: "0 auto",
                  }}
                ></div>
                <h5 className=" ben-title mt-4 mb-3">Implementation and Integration</h5>
                <h6 style={{lineHeight: '1.625em',color:'#627792'}}>Executes the plan and integrates solutions seamlessly into operations.</h6>
              </div>
            </Col>

            {/* Benefit 5 */}
            <Col md={3} className="text-left mb-5">
              <div>
                <div
                  className="mb-2"
                  style={{
                    height: "7px",
                    backgroundColor: "#3d97d3",
                    width: "100%",
                    margin: "0 auto",
                  }}
                ></div>
                <h5 className=" ben-title mt-4 mb-3">Change Management and Employee Training</h5>
                <h6 style={{lineHeight: '1.625em',color:'#627792'}}>Prepares teams for transitions and equips them with necessary skills.</h6>
              </div>
            </Col>
            {/* Benefit 5 */}
            <Col md={3} className="text-left mb-5">
              <div>
                <div
                  className="mb-2"
                  style={{
                    height: "7px",
                    backgroundColor: "#3d97d3",
                    width: "100%",
                    margin: "0 auto",
                  }}
                ></div>
                <h5 className=" ben-title mt-4 mb-3">Continuous Monitoring and Optimization</h5>
                <h6 style={{lineHeight: '1.625em',color:'#627792'}}>Tracks performance and refines systems for optimal results.</h6>
              </div>
            </Col>
            {/* Benefit 5 */}
            <Col md={3} className="text-left mb-5">
              <div>
                <div
                  className="mb-2"
                  style={{
                    height: "7px",
                    backgroundColor: "#3d97d3",
                    width: "100%",
                    margin: "0 auto",
                  }}
                ></div>
                <h5 className=" ben-title mt-4 mb-3">Strategic Review and Future Planning</h5>
                <h6 style={{lineHeight: '1.625em',color:'#627792'}}>Evaluates progress and adjusts strategies for long-term success.</h6>
              </div>
            </Col>

          </Row>


        </Container>
      </section>
    </>
  )
}